module.exports = __webpack_public_path__ + "static/media/ambest.24835453.png";